import type { PresetStorefront } from "@pax/api-contract/presets/v1alpha1";

/** A count at the width a list can afford: "84.2k". */
export function compactCount(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}m`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(1)}k`;
  return String(value);
}

/** How long ago a scenario was published, as a wall tile says it: "today", "2d", "3w", "5mo". */
export function shortAgo(at: string, now = Date.now()): string {
  const days = Math.floor(Math.max(0, now - Date.parse(at)) / 86_400_000);
  if (days < 1) return "today";
  if (days < 7) return `${days}d`;
  if (days < 60) return `${Math.round(days / 7)}w`;
  if (days < 730) return `${Math.round(days / 30)}mo`;
  return `${Math.round(days / 365)}y`;
}

/** What kind of world a scenario is, as its header says it: "Historical". */
export const listedAs = (storefront: Pick<PresetStorefront, "category">) => storefront.category;
